
import React from 'react';
import { Invoice } from '@/components/InvoiceList';

interface CustomerDetailsProps {
  invoice: Invoice;
}

const CustomerDetails: React.FC<CustomerDetailsProps> = ({ invoice }) => {
  return (
    <div className="border-t border-gray-100 pt-6 mt-8 text-gray-600 text-sm">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h3 className="text-xs font-medium uppercase text-gray-400 mb-2">Customer</h3>
          <div>{invoice.customer}</div>
          {invoice.customerEmail && <div>{invoice.customerEmail}</div>}
          {invoice.customerBillingAddress && <div className="text-xs opacity-75">{invoice.customerBillingAddress}</div>}
        </div>
        
        <div className="text-right">
          <h3 className="text-xs font-medium uppercase text-gray-400 mb-2">From</h3>
          <div>KeepMore Financial</div>
          <div className="text-xs opacity-75">123 Finance Street, Suite 100</div>
          <div className="text-xs opacity-75">billing@keepmore.com</div>
        </div>
      </div>
    </div>
  );
};

export default CustomerDetails;
